import React from "react";
import Topbar from "../../components/Super Admin/TopBar/TopbarHelpDesk";
import QueryInbox from "../../components/Super Admin/Helpdesk Management/HelpdeskQueryList"; // replace with ParentList if that's your component
import "../../css/HelpdeskQueryListPage.css";

const QueryInboxPage: React.FC = () => {
  return (
    <>
      <Topbar />
      <QueryInbox />
    </>
  );
};

export default QueryInboxPage;
